export default __webpack_public_path__ + "static/alake-74a0ecb02fdf367e380bd0d0b17eb519.jpg";